/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Share_BusyInputs */

const en_us2_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing the image…`)
};

const pt_br2_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando a imagem…`)
};

const es_419_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando la imagen…`)
};

const pt_pt2_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar a imagem…`)
};

const fr_fr2_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation de l'image…`)
};

const de_de2_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild wird vorbereitet…`)
};

const it_it2_workout_share_share_busy = /** @type {(inputs: Workout_Share_Share_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione dell'immagine…`)
};

/**
* | output |
* | --- |
* | "Preparing the image…" |
*
* @param {Workout_Share_Share_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_share_busy = /** @type {((inputs?: Workout_Share_Share_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Share_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_share_busy(inputs)
	if (locale === "es-419") return es_419_workout_share_share_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_share_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_share_busy(inputs)
	if (locale === "de-DE") return de_de2_workout_share_share_busy(inputs)
	if (locale === "it-IT") return it_it2_workout_share_share_busy(inputs)
	return en_us2_workout_share_share_busy(inputs)
});
export { workout_share_share_busy as "workout-share.share_busy" }